<template>
  <div class="w-100">
    <div class="container-fluid px-0">
      <div class="row align-items-center mb-3 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100 d-flex align-items-center justify-content-between justify-content-lg-start"
          >
            <span class="carousel_title_new">{{ title }}</span>
            <div
              class="d-flex flex-row align-items-center ml-3 view-all-wrapper"
              @click="viewMore()"
              v-if="showMore"
            >
              <span class="see-more-text cursor-pointer">View All</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-0 latest-tv-rails-content" id="landscapeVODCarouselV2">
        <div class="w-100">
          <div class="owl-carousel owl-theme" :id="titleCarousel">
            <div
              class="item"
              v-for="item_vod in items"
              :key="item_vod.id"
              @mouseover="mouseOver"
              @mouseout="mouseOver"
            >
              <vod-card
                :image="imgFiltering(item_vod)"
                :imageFeature="imgFiltering(item_vod, 'feature')"
                :title="item_vod.longTitle"
                :description="item_vod.data.description"
                :link="checkLink(item_vod)"
                :category="item_vod.data.content_type[0].title.en_US"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import noimage from "../../assets/noimage.png";
import vodCard from "../cards/v2/vodCard.vue";
export default {
  name: "vod-rails-landscape-new",
  props: ["title", "datasource", "cat", "cat_id"],
  data: function() {
    return {
      items: [],
      titleCarousel: this.title.replace(/\s/g, "").toLowerCase(),
      noimage: noimage,
      showMore: false,
      contenttype: this.datasource,
      hover: false,
    };
  },
  components: { vodCard },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },

    imageLoadError(event) {
      event.target.src = noimage;
    },
    viewMore() {
      var itemToPass = this.items;
      var contenttype = this.contenttype;

      this.$router.replace(
        "/viewall?cat=" +
          this.cat +
          "&cat_id=" +
          this.cat_id +
          "&contenttype=" +
          contenttype
      );
    },
    goTo(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema;
      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (idSchema == "204") {
        //pod episode
        link = "/podcastplayer?id=" + item.id;
      }

      return link;
    },
    checkIndexForMore() {
      var listlength = this.items;
      if (listlength.length > 8) {
        this.showMore = true;
      }
    },

    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 4,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-md"></span>',
          '<span class="fa fa-chevron-right fa-md"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 8,
            stagePadding: 4,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 16,
            nav: true,
          },
        },
      });
    },

    async initializeContentForStart() {
      var vm = this;

      let response = await axios.get(
        `https://rtb.glueapi.io/v1/content?fieldPath=content_type&fieldValue=${
          vm.cat_id
        }&limit=10&idSchemas=205,207,208,209`,
        {
          responseType: "json",
        }
      );

      vm.items = response.data.data;

      var target = document.getElementById(vm.titleCarousel);
      if (vm.items) {
        this.checkIndexForMore();
        Vue.nextTick(
          function() {
            vm.installOwlCarousel(target);
          }.bind(vm)
        );
      }
    },
  },
  beforeMount() {
    setTimeout(
      function() {
        this.initializeContentForStart();
      }.bind(this),
      1000
    );
  },
};
</script>

<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#landscapeVODCarouselV2 .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #landscapeVODCarouselV2 .owl-theme:hover {
    z-index: 111;
  }

  #landscapeVODCarouselV2 .owl-theme {
    height: auto;
  }
  #landscapeVODCarouselV2 .owl-item {
    z-index: 1;
  }
  #landscapeVODCarouselV2 .owl-item:hover {
    transition: 0.1s all ease-in-out;
    width: 100%;
    z-index: 2000;
  }

  #landscapeVODCarouselV2 .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #landscapeVODCarouselV2 .owl-theme .owl-nav {
    position: absolute;
    top: -64px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
    z-index: 11;
  }

  #landscapeVODCarouselV2 .owl-prev {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
    z-index: 1;
  }

  #landscapeVODCarouselV2 .owl-next {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    z-index: 1;
  }

  #landscapeVODCarouselV2 .owl-next span,
  #landscapeVODCarouselV2 .owl-prev span {
    color: rgb(0, 0, 0) !important;
  }
}
</style>

<style scoped>
.carousel_title_new {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(250, 185, 19, 1);
}
.view-all-wrapper {
  border-radius: 8px;
  background: rgba(250, 185, 19, 1);
  padding: 6px 12px;
}
.see-more-text {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 1);
}

@media only screen and (max-width: 768px) {
  .carousel_title_new {
    font-size: 18px;
    line-height: 22px;
  }
  .see-more-text {
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
